// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/9f6a91b8/" + chunkId + "." + __webpack_require__.h() + ".v9f6a91b8.js";
};